import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';
import { findIndex, flatten } from 'lodash';
import angular from 'angular';

export default function($log, $stateParams, $uibModal, $state, ApiClass, Swal, HelperClass) {
  'ngInject';
  const vm = this;

  vm.$onChanges = init;

  vm.addRegistrantsFromCSV = data => {
    data.filter(({ email }) => HelperClass.validateEmail(email)).forEach(({ email, first, last }) => {
      vm.temp.push({ email: email.trim().toLowerCase(), first, last, selected: true });
    });

    return updateEvent().catch(error => {
      $log.error(error);
      throw error;
    });
  };

  vm.remove = body => {
    if (body && body.data && body.data.rejected && body.data.rejected.length) {
      return Swal.html(
        'Registration Error',
        `<p>The following user(s) are already registered for this event.<br>
         If they are registered for another location, please use the move registrant feature to change their registration location. </p>
        <ul class="unstyled">
          ${body.data.rejected.map(({ email }) => '<li>' + email + '</li>').join('')}
        </ul>`,
        'warning',
        20000
      ).then(() => {
        vm.temp = angular.copy(vm.temp).filter(({ selected }) => !selected);
        return updateEvent();
      });
    }

    vm.temp = angular.copy(vm.temp).filter(({ selected }) => !selected);
    return updateEvent();
  };

  vm.selectAll = selected => {
    vm.temp.forEach(user => (user.selected = selected));
  };

  vm.selectUsersCount = () => vm.temp.filter(({ selected }) => selected).length;

  vm.selectedEmployees = () => {
    let filterEmployees = [];
    if (vm.temp)
      filterEmployees = [
        ...vm.temp.map(({ email }) => email),
        ...flatten(vm.event.locations.map(({ attendees }) => (attendees || []).map(({ email }) => email)))
      ];
    if (vm.state === 'tempInvites' && vm.location && vm.location.invitations) {
      filterEmployees.push(...vm.location.invitations.map(({ recipient_email }) => recipient_email));
    }

    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        template: employeeModalTemplate,
        controller: EmployeeModalController(filterEmployees, true),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(selectedEmployees => {
        if (!selectedEmployees) return;
        const invitees = selectedEmployees.map(({ first, last, email }) => ({
          first,
          last,
          email,
          selected: true
        }));
        vm.temp.push(...invitees);
        return updateEvent();
      })
      .catch(error => {
        if (error === 'backdrop click') return;
        $log.error(error);
        throw error;
      });
  };

  vm.submit = function(type) {
    const selectedUsers = vm.temp.filter(({ selected }) => selected);
    vm.temp = angular.copy(vm.temp).filter(({ selected }) => !selected);
    vm.sendLoading = true;

    updateEvent()
      .then(() => {
        if (type === 'update') {
          return vm.update({
            data: selectedUsers,
            includeRelatedEvents: vm.includeRelatedEvents,
            oneClickRegistration: vm.oneClickRegistration,
            suppress: !!vm.suppress
          });
        }
        if (type === 'waitlist') {
          const id = $stateParams.eventid;
          return ApiClass.eventsIdTypePut(
            { id, type: 'waitlistAttendees' },
            { users: selectedUsers, location: vm.location.location, suppressEmail: !!vm.suppress },
            { queryParams: { manage: true } }
          );
        }
      })
      .then(data => {
        if (data.status === 400) throw data.data;
        return vm.remove();
      })
      .then(() => {
        $state.reload();
      })
      .catch(error => {
        handleSubmitError(error);
        vm.temp = [...angular.copy(vm.temp), ...selectedUsers];
        updateEvent();
        vm.sendLoading = false;
        $log.error(error);
      });
  };

  function handleSubmitError(error) {
    if (error.description === 'Event waitlist is set to off') {
      Swal.alert(
        'Hold up!',
        'The waitlist is currently disabled for this event.  Please update the waitlist setting and try again.',
        'error'
      );
    }
    if (error.description === 'Event waitlist is set to automatic and has openings.') {
      Swal.alert(
        'Hold up!',
        "The waitlist setting for this event is currently set to 'Automatic' and there are still open registration slots.  As a result, waitlisted registrants will be automatically registered until the event's capacity has been met.",
        'error'
      );
    }
  }

  function updateEvent() {
    const eventUpdate = {
      course_id: $stateParams.courseid,
      event_id: $stateParams.eventid
    };

    if (vm.location && vm.location.primary) {
      if (vm.state === 'tempInvites') eventUpdate.temp_invites = vm.temp;
      if (vm.state === 'tempRegistrations') eventUpdate.temp_registrations = vm.temp;
    }

    if (!vm.location || !vm.location.primary) {
      const locations = angular.copy(vm.event.locations);
      const location = vm.location ? vm.location.location : undefined;
      const index = findIndex(locations, { location });
      locations[index][vm.state] = vm.temp;
      locations.shift();
      eventUpdate.locations = locations;
    }

    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event: eventUpdate });
  }

  function init() {
    if (!vm.location) return;
    vm.temp = angular.copy(vm.location[vm.state]);
    vm.csvColumns = ['email', 'first', 'last'];
    vm.csvExampleData = [['john@prolaera.com', 'John', 'Doe'], ['jane@prolaera.com', 'Jane', 'Doe']];
    vm.showWaitlist =
      vm.event.waitlist === 'manual' || (!!vm.event.registrationOpenings && vm.event.waitlist === 'automatic');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/usersSelect/controller.js